const state = {
  tnc_id: [],
};

export default state;
